/**
 * @module "ethpm/storage"
 */

export * from './service';
